import React from "react";

const NotFound = () => {
  return <h1 className="section-title">صفحه مورد نظر یافت نشد</h1>;
};

export default NotFound;
